import WidgetSchedule from '@/screens/WidgetSchedule';

export default function ExternalWidgetV1ScheduleEventIdRoute() {
  return <WidgetSchedule />;
}
